import { createRoot } from 'react-dom/client'
import { ApolloProvider, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import ErrorHandler from "./lib/ErrorHandler";

import App from './components/App';
import CssReset from "./lib/CssReset";

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: import.meta.env.VITE_API_URL,
  })
});

const root = document.getElementById('root');

createRoot(root).render(
  <ErrorHandler>
    <CssReset />
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </ErrorHandler>
);
